<div class="mt-3 ml-3 custom">
    <p>Logging in user, Please wait...</p>
</div>

<eos-loader [showloader]="true"></eos-loader>